import React from 'react'

const Lock = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/title',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M6 7.55v-3.3C6 2.458 8.346 1 10 1s4 1.458 4 3.25v3.3'
        stroke={primaryColor}
        strokeWidth='1.2'
      />
      <path
        d='M17 19H3v-8.262c0-1.377.796-2.63 1.982-3.116 1.06-.436 2.854-.955 5.018-.955 2.164 0 3.958.519 5.018.955C16.203 8.108 17 9.359 17 10.738V19z'
        stroke={primaryColor}
        strokeWidth='1.2'
      />
      <path
        d='M10 12v3'
        stroke={secondaryColor}
        strokeWidth='2'
        strokeLinecap='round'
      />
    </g>
  </svg>
)

export default Lock
